import { all, fork } from 'redux-saga/effects'
import { map } from 'lodash'
import { sagas } from '@/contexts'

export default function* rootSaga() {
  yield all(map(sagas, saga => fork(saga)))
}
